import React from 'react'

import { shape, number, bool } from 'prop-types'

import { formatMoneyValue } from '../../../formatter'

function PayoutRateBanner({ payoutRate = null }) {
  const {
    rate, isCustom, amountToNext, nextRate, levelId,
  } = payoutRate || {}

  const showNextLevel = payoutRate && !isCustom && levelId < 26

  return (
    <div className="overview-payout-banner cgt-text-medium">
      {'Your payout rate: '}
      <span className="overview-payout-banner__rate cgt-text-medium--semi-bold">
        {rate != null ? `${rate}%` : '-'}
      </span>
      {showNextLevel && (
        <span>
          {' \u00B7 Sell '}
          <span className="overview-payout-banner__amount cgt-text-medium--semi-bold">
            ${formatMoneyValue(amountToNext)}
          </span>
          {' more to reach '}
          <span className="cgt-text-medium--semi-bold">{nextRate}%</span>
        </span>
      )}
    </div>
  )
}

PayoutRateBanner.propTypes = {
  payoutRate: shape({
    rate: number.isRequired,
    isCustom: bool.isRequired,
    amountToNext: number.isRequired,
    nextRate: number.isRequired,
    levelId: number.isRequired,
  }),
}

export default PayoutRateBanner
